import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules'
Swiper.use([Pagination, Navigation, Autoplay]);

const reviewSwiper = new Swiper('.reviews-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 50,
    loop: true,
    navigation:{
      prevEl: '.reviews-swiper-prev',
      nextEl: '.reviews-swiper-next',
    },
    autoplay:{
      delay: 5000
    },
    breakpoints: {
        600:{
            slidesPerView: 1.5
        },
        1200:{
            slidesPerView: 2.5
        },
    },
});
